/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_UserLogInAndSecurity_UserLogInAndSecurityDto } from '../models/Wealthlane_CustomerService_Dtos_UserLogInAndSecurity_UserLogInAndSecurityDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserLogInAndSecurityService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_UserLogInAndSecurity_UserLogInAndSecurityDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppUserLogInAndSecurityUserLogInAndSecurity(): CancelablePromise<Wealthlane_CustomerService_Dtos_UserLogInAndSecurity_UserLogInAndSecurityDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/user-log-in-and-security/user-log-in-and-security',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
